var React = require('react');

function SignupArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.495 6.49497C40.7683 6.22161 40.7683 5.77839 40.495 5.50503L36.0402 1.05025C35.7668 0.776885 35.3236 0.776885 35.0503 1.05025C34.7769 1.32362 34.7769 1.76683 35.0503 2.0402L39.0101 6L35.0503 9.9598C34.7769 10.2332 34.7769 10.6764 35.0503 10.9497C35.3236 11.2231 35.7668 11.2231 36.0402 10.9497L40.495 6.49497ZM40 5.3L6.11959e-08 5.3L-6.11959e-08 6.7L40 6.7L40 5.3Z","fill":"#FEFEFE"}));
}

SignupArrowIcon.defaultProps = {"width":"41","height":"12","viewBox":"0 0 41 12","fill":"none"};

module.exports = SignupArrowIcon;

SignupArrowIcon.default = SignupArrowIcon;
